/* tslint:disable */
/* eslint-disable */
import { InstitutionDisplayModel as AceXFoundPortalCoreCaqModelsInstitutionDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/institution-display-model';
import { KontaktDisplayModel as AceXFoundPortalCoreCaqModelsKontaktDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/kontakt-display-model';
import { GlobalEnumsAceAntragstellungerfolgtfuer as AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-antragstellungerfolgtfuer';
import { GlobalEnumsAceInformationsquelle as AceXFoundPortalCoreEntitiesGlobalEnumsAceInformationsquelle } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-informationsquelle';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { InstitutionDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup } from '@/api/model-index';
import { KontaktDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup } from '@/api/model-index';

export interface IContactDataDisplayModel {
  ansprechpartner?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  antragsteller?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  antragstellungerfolgtfuer?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer;
  cbweitererAnsprechpartner?: null | boolean;
  cbweitererVertretungsberechtigter?: null | boolean;
  informationsquelle?: AceXFoundPortalCoreEntitiesGlobalEnumsAceInformationsquelle;
  institution?: AceXFoundPortalCoreCaqModelsInstitutionDisplayModel;
  vertretungsberechtigter?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  weitererAnsprechpartner?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  weitererVertretungsberechtigter?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
}
export class ContactDataDisplayModel extends BaseModel implements IContactDataDisplayModel {
  ansprechpartner?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  antragsteller?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  antragstellungerfolgtfuer?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer;
  cbweitererAnsprechpartner?: null | boolean;
  cbweitererVertretungsberechtigter?: null | boolean;
  informationsquelle?: AceXFoundPortalCoreEntitiesGlobalEnumsAceInformationsquelle;
  institution?: AceXFoundPortalCoreCaqModelsInstitutionDisplayModel;
  vertretungsberechtigter?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  weitererAnsprechpartner?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
  weitererVertretungsberechtigter?: AceXFoundPortalCoreCaqModelsKontaktDisplayModel;
}
class BaseContactDataDisplayModelFormGroup extends FormGroup {
  private static _instance: ContactDataDisplayModelFormGroup;
  
  public static get Instance(): ContactDataDisplayModelFormGroup {
    this._instance = new ContactDataDisplayModelFormGroup({
      ansprechpartner: AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup.Instance,
      antragsteller: AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup.Instance,
      antragstellungerfolgtfuer: new FormControl(null),
      cbweitererAnsprechpartner: new FormControl(null),
      cbweitererVertretungsberechtigter: new FormControl(null),
      informationsquelle: new FormControl(null),
      institution: AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup.Instance,
      vertretungsberechtigter: AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup.Instance,
      weitererAnsprechpartner: AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup.Instance,
      weitererVertretungsberechtigter: AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup.Instance,
    });

    return this._instance;
  }
}


export class ContactDataDisplayModelFormGroup extends BaseContactDataDisplayModelFormGroup {
  public get Ansprechpartner(): AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup {
    return this.controls["ansprechpartner"] as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup;
  }
  public get Antragsteller(): AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup {
    return this.controls["antragsteller"] as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup;
  }
  public get Antragstellungerfolgtfuer(): FormControl {
    return this.controls["antragstellungerfolgtfuer"] as FormControl;
  }
  public get CbweitererAnsprechpartner(): FormControl {
    return this.controls["cbweitererAnsprechpartner"] as FormControl;
  }
  public get CbweitererVertretungsberechtigter(): FormControl {
    return this.controls["cbweitererVertretungsberechtigter"] as FormControl;
  }
  public get Informationsquelle(): FormControl {
    return this.controls["informationsquelle"] as FormControl;
  }
  public get Institution(): AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup {
    return this.controls["institution"] as AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup;
  }
  public get Vertretungsberechtigter(): AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup {
    return this.controls["vertretungsberechtigter"] as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup;
  }
  public get WeitererAnsprechpartner(): AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup {
    return this.controls["weitererAnsprechpartner"] as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup;
  }
  public get WeitererVertretungsberechtigter(): AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup {
    return this.controls["weitererVertretungsberechtigter"] as AceXFoundPortalCoreCaqModelsKontaktDisplayModelFormGroup;
  }
  

}

export module ContactDataDisplayModelForm
  {
    export class FormFields
    {
      static _ansprechpartner: string = "ansprechpartner";
      static _antragsteller: string = "antragsteller";
      static _antragstellungerfolgtfuer: string = "antragstellungerfolgtfuer";
      static _cbweitererAnsprechpartner: string = "cbweitererAnsprechpartner";
      static _cbweitererVertretungsberechtigter: string = "cbweitererVertretungsberechtigter";
      static _informationsquelle: string = "informationsquelle";
      static _institution: string = "institution";
      static _vertretungsberechtigter: string = "vertretungsberechtigter";
      static _weitererAnsprechpartner: string = "weitererAnsprechpartner";
      static _weitererVertretungsberechtigter: string = "weitererVertretungsberechtigter";
    }
  }

